import React, { ReactElement } from "react";
import {
  Aflossing,
  ToelichtingHypotheekvormenHoofdstuk,
} from "../../../.generated/rapportage/rapportagetypes";
import { Paragraph } from "../components/Paragraph";
import { LineChart } from "../components/Chart";
import { ChartDataset } from "chart.js";
import Heading from "../components/Heading";
import { Chapter } from "../components/Chapter";

type ToelichtingHypotheekvormenProps = {
  toelichtingHypotheekvormen: ToelichtingHypotheekvormenHoofdstuk;
};

const getDataset = (data: Aflossing[]): ChartDataset<"line">[] => {
  return [
    {
      label: "Aflossing",
      fill: true,
      data: data.map((x) => x.aflossingsbedrag),
      borderColor: "rgb(59, 131, 199)",
      backgroundColor: "rgba(59, 121, 199, 0.5)",
    },
    {
      label: "Netto maandlast",
      data: data.map((x) => x.nettoMaandlast),
      borderColor: "rgb(170, 199, 88)",
      backgroundColor: "rgba(170, 199, 88, 0.5)",
    },
    {
      label: "Bruto maandlast",
      data: data.map((x) => x.brutoMaandlast),
      borderColor: "rgb(255, 99, 99)",
      backgroundColor: "rgba(255, 99, 99, 0.5)",
    },
  ];
};

export const ToelichtingHypotheekvormen = ({
  toelichtingHypotheekvormen,
}: ToelichtingHypotheekvormenProps): ReactElement => {
  const aflossingenAnnuiteitenHypotheekData =
    toelichtingHypotheekvormen.toelichtingHypotheekvormen
      ?.aflossingenAnnuiteitenHypotheek;
  const aflossingenLineaireHypotheekData =
    toelichtingHypotheekvormen.toelichtingHypotheekvormen
      ?.aflossingenLineaireHypotheek;

  return (
    <Chapter>
      {toelichtingHypotheekvormen?.titel && (
        <Heading
          text={`${toelichtingHypotheekvormen.titel}`}
        />
      )}
      
      <Paragraph
        paragraaf={toelichtingHypotheekvormen?.paragrafen?.["p40401"]}
      />

      <Paragraph
        paragraaf={toelichtingHypotheekvormen?.paragrafen?.["p40402"]}
      />

      <LineChart
        labels={
          aflossingenAnnuiteitenHypotheekData?.map((x) => x.jaar.toString()) ||
          []
        }
        datasets={getDataset(aflossingenAnnuiteitenHypotheekData || [])}
      />

      <Paragraph
        paragraaf={toelichtingHypotheekvormen?.paragrafen?.["p40404"]}
      />

      <LineChart
        labels={
          aflossingenLineaireHypotheekData?.map((x) => x.jaar.toString()) || []
        }
        datasets={getDataset(aflossingenLineaireHypotheekData || [])}
      />
    </Chapter>
  );
};
